import * as React from 'react';

import { observer } from 'mobx-react';

import { ITranslationsCollection } from '@estee/elc-service';
import { ELC_RAMP } from '@estee/elc-service-view-names';

import { VulcanContext } from '~context/VulcanContext';
import { IRampPreloadedConfig } from '~domain/entities/Config';
import { RampMain } from '~views/RampMain';

import { RampViewController } from './RampViewController';

export interface IRampProps {
    config: IRampPreloadedConfig;
    viewController: RampViewController;
    translations: ITranslationsCollection;
}

@observer
class Ramp extends React.Component<IRampProps> {
    async componentDidMount() {
        await this.props.viewController.loaded();
    }

    render() {
        const { isLoading } = this.props.viewController.data;

        return (
            <VulcanContext translations={this.props.translations} config={this.props.config}>
                <RampMain isLoading={isLoading} serviceViewName={ELC_RAMP} />
            </VulcanContext>
        );
    }
}

export default Ramp;
